(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["df-free-shipping-progress"] && !Shopify.designMode) return;
  try {
    (() => {
  const template = document.getElementById('df-shipping-template');
  if (!template) return;
  const threshold = 2500;
  const config = template.dataset;
  let total = Number(config.total) || 0;
  let currency = config.currency;
  let node;
  let request = 0;
  let timer;
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' });
  function update() {
    if (!node) return;
    const eligibleMarket = config.country === 'US' && currency === 'USD';
    const message = eligibleMarket
      ? (total >= threshold ? config.reached : config.remaining.replace('__amount__', money.format(Math.max(0, threshold - total) / 100)))
      : config.international;
    const text = node.querySelector('.df-shipping-progress__message');
    if (text.textContent !== message) text.textContent = message;
    const bar = node.querySelector('progress');
    bar.hidden = !eligibleMarket;
    bar.value = Math.min(threshold, Math.max(0, total));
  }
  function attach() {
    if (node?.isConnected) return;
    const button = document.querySelector('gp-product-button button[name="add"], main form[action*="/cart/add"] button[name="add"], main button[name="add"]');
    if (!button) return;
    node = template.content.firstElementChild.cloneNode(true);
    const anchor = button.closest('gp-product-button') || button;
    anchor.insertAdjacentElement('afterend', node);
    update();
  }
  async function refresh() {
    const current = ++request;
    try {
      const root = config.root.endsWith('/') ? config.root : config.root + '/';
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (current !== request || !Number.isFinite(cart.total_price)) return;
      total = cart.total_price;
      currency = cart.currency;
      attach();
      update();
    } catch (_) {}
  }
  function scheduleRefresh() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 120);
  }
  attach();
  const observer = new MutationObserver(() => { if (!node?.isConnected) attach(); });
  observer.observe(document.body, { childList: true, subtree: true });
  ['rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:discount.change', 'cart:updated', 'cart:change'].forEach(event => document.addEventListener(event, scheduleRefresh));
  document.addEventListener('click', event => {
    if (event.target.closest('button[name="add"]')) setTimeout(scheduleRefresh, 900);
  });
  window.addEventListener('pageshow', scheduleRefresh);
  refresh();
})();
  } catch(e) { console.error(e); }
})();

})();
